import { CanvasMode, VSWebClient } from './vsweb-client-impl'
import Stats from './stats'

// type Renderer = any;

const SVG_NS = 'http://www.w3.org/2000/svg'
const XLINK_NS = 'http://www.w3.org/1999/xlink'


export default class VSCanvas {

	stats: Stats;

	modeTransition: boolean = false;

	target: HTMLElement;
	canvas2D: HTMLCanvasElement;
	context2D: CanvasRenderingContext2D;

	width: number;
	height: number;

	image: HTMLImageElement;

	rectStartX: number;
	rectStartY: number;

	context: Window;

	client: VSWebClient;

	scaleFactor: number = 1.0;

	scaledWidth: number = 0
	scaledHeight: number = 0

	rightClickTimeStamp: number
    lang: string
    conextMenuEventListener

    //Multisessions
    mouseLayer: HTMLCanvasElement;
	layerContext: CanvasRenderingContext2D;
	tmpCanvas: HTMLCanvasElement;

	constructor(el: HTMLElement, client: VSWebClient, context?: Window) {
		this.client = client
		this.context = context || window

		this.target = el
		// clear all children of the target
		while (this.target.firstChild) {
			this.target.removeChild(this.target.firstChild)
		}

        this.width = this.client.initOptions.spectatorMode ? document.body.clientWidth : this.target.offsetWidth;
        this.height = this.client.initOptions.spectatorMode ? document.body.clientHeight : this.target.offsetHeight;

		this.lang = 'ENU'

		this.canvas2D = <HTMLCanvasElement>this.context.document.createElement('canvas')
		this.canvas2D.setAttribute('class', '2DCanvas')
		// this.canvas2D.setAttribute('tabIndex', '1000')
		this.client.on('Resize', () =>
        {
			$('#contextMenu').remove()
			$(document).off('click', this.closeContextMenu)
			$(document).off('keyup', this.closeContextMenu)
		})

		this.client.on('@changeLang', (lang) => {
			this.lang = lang
		})

        $(this.canvas2D).on('mousedown', (e) =>
        {
			if(e.which === 3)
			{
				this.rightClickTimeStamp = e.timeStamp
			}
		})

		//Temp layer
		if (this.client.initOptions.showBackgroundCanvas)
		{
			this.tmpCanvas = document.createElement('canvas');
			this.tmpCanvas.setAttribute('class', '2DCanvas');
			this.tmpCanvas.width = this.width;
			this.tmpCanvas.height = this.height;
			this.target.appendChild(this.tmpCanvas);
		}
		//VS Canvas
        this.canvas2D.width = this.width;
        this.canvas2D.height = this.height;
        this.target.appendChild(this.canvas2D);
        this.context2D = this.canvas2D.getContext('2d');
		//Apply mouse layer canvas for multisessions
		if (this.client.initOptions.showSpectatorCanvas)
		{
			this.mouseLayer = document.createElement('canvas');
			this.mouseLayer.setAttribute('class', '2DCanvas');
			this.mouseLayer.width = this.width;
			this.mouseLayer.height = this.height;
			this.mouseLayer.style.pointerEvents = 'none';
			this.target.appendChild(this.mouseLayer);
			this.layerContext = this.mouseLayer.getContext('2d');
		}

        this.image = new Image();

		// do not stretch image any more
		// this.image.onload = () => {
		// 	this.context2D.drawImage(this.image, 0, 0, this.image.width, this.image.height,
		// 		0, 0, this.canvas2D.width, this.canvas2D.height)
		// }

        // this.image.onload = () => {
		// 	this.context2D.drawImage(this.image, 0, 0, this.image.width, this.image.height,
		// 		0, 0, this.canvas2D.width, this.canvas2D.height)
        // }
        this.image.onload = () =>
        {
            if (this.client.initOptions.spectatorMode)
            {
                this.context2D.clearRect(0, 0, this.canvas2D.width, this.canvas2D.height);
                this.context2D.drawImage(this.image, 0, 0, this.image.width, this.image.height,
                    0, 0, this.target.clientWidth, this.target.clientHeight);
            }
            else
            {
                this.context2D.drawImage(this.image, 0, 0);
            }

        }
		//FIX: DencoHappel
		if (this.client.stats) {
			this.client.stats.onDecodingLag = () => {
				const rate = 0.8
				this.scaleFactor = this.scaleFactor * rate
				let width = Math.floor(this.width * this.scaleFactor)
				let height = Math.floor(this.height * this.scaleFactor)

				console.log(`new dimension: width: ${width} height: ${height} with a factor ${this.scaleFactor}`)

				const XML = `<Call Method="SetScaleFactor"><Factor>${this.scaleFactor}</Factor></Call>`
				this.client.command.executeXML(XML)
			}
		}
		
		this.canvas2D.addEventListener('dragover', function(e) {
			e.stopPropagation();
            e.preventDefault();
		});


        this.conextMenuEventListener = this.createContextListener.bind(this);
        this.registerContextMenu();
    }

    destroy ()
    {
        //Remove DOM elements
        while (this.target.firstChild)
        {
			this.target.removeChild(this.target.firstChild)
        }
        //Reset variables
        this.client.removeAllListeners();
        this.reset();
    }

    reset ()
    {
        this.client = null;
        this.context = null;
        this.width = null;
        this.height = null;
        this.lang = null;
        this.canvas2D = null;
        this.image = null;
        this.context2D = null;
    }

    translate (langKey, lang)
    {
        if (!lang)
        {
            lang = 'ENU';
        }
        if (_lang_data[langKey] && _lang_data[langKey][lang])
        {
            return _lang_data[langKey][lang];
        }
        else if (_custom_lang_data[langKey] && _custom_lang_data[langKey][lang])
        {
            return _custom_lang_data[langKey][lang];
        }
        else if (_lang_data[langKey] && _lang_data[langKey]['ENU'])
        {
            return _lang_data[langKey]['ENU'];
        }
        else if (_custom_lang_data[langKey] && _custom_lang_data[langKey]['ENU'])
        {
            return _custom_lang_data[langKey]['ENU'];
        }
        return langKey;
    }

    unregisterContextMenu ()
    {
        if (this.canvas2D)
        {
            this.canvas2D.removeEventListener('contextmenu', this.conextMenuEventListener);
        }
    }

    registerContextMenu ()
    {
        if (this.canvas2D)
        {
            this.canvas2D.addEventListener('contextmenu', this.conextMenuEventListener);
        }
    }

    createContextListener (ev)
    {
        ev.preventDefault()
        $('#contextMenu').remove()
        $(document).off('click', this.closeContextMenu)
        $(document).off('keyup', this.closeContextMenu)
        if (this.rightClickTimeStamp && ev.timeStamp - this.rightClickTimeStamp < 200)
        {
            this.createContextMenu(ev)
        }
    }

	createContextMenu(ev) {
		let contextMenu = document.createElement('div')
		contextMenu.style.left = ev.pageX + 'px'
		contextMenu.style.top = ev.pageY + 'px'
		contextMenu.id = 'contextMenu'
		contextMenu.className = 'context-menu'


		//Create 'Hide' entry
		let contextHideRow = document.createElement('div')
		contextHideRow.className = 'context-menu-row'

		let contextHideIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextHideIcon).addClass('context-menu-icon')
		let hideIcon = document.createElementNS(SVG_NS, 'use')
		hideIcon.setAttributeNS(XLINK_NS, 'href', '#3_verbergen')
		contextHideIcon.appendChild(hideIcon)

		let contextHideText = document.createElement('div')
		contextHideText.className = 'context-menu-text'
        contextHideText.textContent = this.translate('ID_RIBBON_HIDE', this.lang);

		$(contextHideRow).click(() => {
			this.callContextSelectionMethod('Hide')
		})
		contextHideRow.appendChild(contextHideIcon)
		contextHideRow.appendChild(contextHideText)

		//Create 'Show' entry
		let contextShowRow = document.createElement('div')
		contextShowRow.className = 'context-menu-row'

		let contextShowIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextShowIcon).addClass('context-menu-icon')
		let showIcon = document.createElementNS(SVG_NS, 'use')
		showIcon.setAttributeNS(XLINK_NS, 'href', '#4_anzeigen')
		contextShowIcon.appendChild(showIcon)

		let contextShowText = document.createElement('div')
		contextShowText.className = 'context-menu-text'
		contextShowText.textContent = this.translate('ID_RIBBON_SHOW', this.lang);

		$(contextShowRow).click(() => {
			this.callContextSelectionMethod('Show')
		})
		contextShowRow.appendChild(contextShowIcon)
		contextShowRow.appendChild(contextShowText)

		//Create 'Isolate' entry
		let contextIsolateRow = document.createElement('div')
		contextIsolateRow.className = 'context-menu-row'

		let contextIsolateIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextIsolateIcon).addClass('context-menu-icon')
		let isolateIcon = document.createElementNS(SVG_NS, 'use')
		isolateIcon.setAttributeNS(XLINK_NS, 'href', '#3_isolieren')
		contextIsolateIcon.appendChild(isolateIcon)

		let contextIsolateText = document.createElement('div')
		contextIsolateText.className = 'context-menu-text'
        contextIsolateText.textContent = this.translate('ID_RIBBON_ISOLATE', this.lang);

		$(contextIsolateRow).click(() => {
			this.callContextSelectionMethod('Isolate')
		})
		contextIsolateRow.appendChild(contextIsolateIcon)
        contextIsolateRow.appendChild(contextIsolateText)

        //Create 'Show all' entry
		let contextShowAllRow = document.createElement('div')
		contextShowAllRow.className = 'context-menu-row'

		let contextShowAllIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextShowAllIcon).addClass('context-menu-icon')
		let showAllIcon = document.createElementNS(SVG_NS, 'use')
		showAllIcon.setAttributeNS(XLINK_NS, 'href', '#1_alles_anzeigen')
		contextShowAllIcon.appendChild(showAllIcon)

		let contextShowAllText = document.createElement('div')
		contextShowAllText.className = 'context-menu-text'
        contextShowAllText.textContent = this.translate('ID_RIBBON_SHOW_ALL', this.lang);

		$(contextShowAllRow).click(() =>
		{
			this.callContextMethod('ShowAll')
		})
		contextShowAllRow.appendChild(contextShowAllIcon)
		contextShowAllRow.appendChild(contextShowAllText)

		//Create 'Invert visibility' entry
		let contextInvertVisRow = document.createElement('div')
		contextInvertVisRow.className = 'context-menu-row'

		let contextInvertVisIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextInvertVisIcon).addClass('context-menu-icon')
		let invertVisIcon = document.createElementNS(SVG_NS, 'use')
		invertVisIcon.setAttributeNS(XLINK_NS, 'href', '#5_sichtbarkeit_umkehren')
		contextInvertVisIcon.appendChild(invertVisIcon)

		let contextInvertVisText = document.createElement('div')
		contextInvertVisText.className = 'context-menu-text'
        contextInvertVisText.textContent = this.translate('ID_RIBBON_INVERT_VISIBILITY', this.lang);

		$(contextInvertVisRow).click(() =>
		{
			this.callContextMethod('InvertVisibility')
		})
		contextInvertVisRow.appendChild(contextInvertVisIcon)
		contextInvertVisRow.appendChild(contextInvertVisText)

		//Create 'Delete' entry
		let contextDeleteRow = document.createElement('div')
		contextDeleteRow.className = 'context-menu-row'

		let contextDeleteIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextDeleteIcon).addClass('context-menu-icon')
		let deleteIcon = document.createElementNS(SVG_NS, 'use')
		deleteIcon.setAttributeNS(XLINK_NS, 'href', '#6_loeschen')
		contextDeleteIcon.appendChild(deleteIcon)

		let contextDeleteText = document.createElement('div')
		contextDeleteText.className = 'context-menu-text'
        contextDeleteText.textContent = this.translate('ID_RIBBON_DELETE', this.lang);

		$(contextDeleteRow).click(() => {
            this.client.deleteSelection();
		})
		contextDeleteRow.appendChild(contextDeleteIcon)
		contextDeleteRow.appendChild(contextDeleteText)

		//Create 'Ghost' entry
		let contextGhostRow = document.createElement('div')
		contextGhostRow.className = 'context-menu-row'

		let contextGhostIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextGhostIcon).addClass('context-menu-icon')
		let ghostIcon = document.createElementNS(SVG_NS, 'use')
		ghostIcon.setAttributeNS(XLINK_NS, 'href', '#7_ghost')
		contextGhostIcon.appendChild(ghostIcon)

		let contextGhostText = document.createElement('div')
		contextGhostText.className = 'context-menu-text'
        contextGhostText.textContent = this.translate('ID_RIBBON_GHOST', this.lang);

		$(contextGhostRow).click(() => {
			this.callContextSelectionMethod('Ghost')
		})
		contextGhostRow.appendChild(contextGhostIcon)
		contextGhostRow.appendChild(contextGhostText)

		//Create 'UnGhost' entry
		let contextUnGhostRow = document.createElement('div')
		contextUnGhostRow.className = 'context-menu-row'

		let contextUnGhostIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextUnGhostIcon).addClass('context-menu-icon')
		let unGhostIcon = document.createElementNS(SVG_NS, 'use')
		unGhostIcon.setAttributeNS(XLINK_NS, 'href', '#8_ghost_ausschalten')
		contextUnGhostIcon.appendChild(unGhostIcon)

		let contextUnGhostText = document.createElement('div')
		contextUnGhostText.className = 'context-menu-text'
        contextUnGhostText.textContent = this.translate('ID_RIBBON_UNGHOST', this.lang);

		$(contextUnGhostRow).click(() => {
			this.callContextSelectionMethod('UnGhost')
		})
		contextUnGhostRow.appendChild(contextUnGhostIcon)
		contextUnGhostRow.appendChild(contextUnGhostText)


		let firstDivider = document.createElement('hr')

		
		//Create 'Activate coordinate system' entry
		let contextActivateCSRow = document.createElement('div')
		contextActivateCSRow.className = 'context-menu-row'

		let contextActivateCSIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextActivateCSIcon).addClass('context-menu-icon')
		let activateCSIcon = document.createElementNS(SVG_NS, 'use')
		activateCSIcon.setAttributeNS(XLINK_NS, 'href', '#8_aktivieren')
		contextActivateCSIcon.appendChild(activateCSIcon)

		let contextActivateCSText = document.createElement('div')
		contextActivateCSText.className = 'context-menu-text'
        contextActivateCSText.textContent = this.translate('ID_RIBBON_ACTIVATE_COORDINATESYSTEM', this.lang);

		$(contextActivateCSRow).click(() => {
			this.callContextMethod('ActivateSelectedCoordinateSystem')
		})
		contextActivateCSRow.appendChild(contextActivateCSIcon)
		contextActivateCSRow.appendChild(contextActivateCSText)

		//Create 'Reset coordinate system' entry
		let contextResetCSRow = document.createElement('div')
		contextResetCSRow.className = 'context-menu-row'

		let contextResetCSIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextResetCSIcon).addClass('context-menu-icon')
		let resetCSIcon = document.createElementNS(SVG_NS, 'use')
		resetCSIcon.setAttributeNS(XLINK_NS, 'href', '#9_zuruecksetzen')
		contextResetCSIcon.appendChild(resetCSIcon)

		let contextResetCSText = document.createElement('div')
		contextResetCSText.className = 'context-menu-text'
        contextResetCSText.textContent = this.translate('ID_RESET_COORDINATESYSTEM', this.lang);

		$(contextResetCSRow).click(() => {
			this.callContextMethod('ResetCoordinateSystem')
		})
		contextResetCSRow.appendChild(contextResetCSIcon)
		contextResetCSRow.appendChild(contextResetCSText)

		//Create 'Focus' entry
		let contexFocusRow = document.createElement('div')
		contexFocusRow.className = 'context-menu-row'

		let contextFocusIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextFocusIcon).addClass('context-menu-icon')
		let focusIcon = document.createElementNS(SVG_NS, 'use')
		focusIcon.setAttributeNS(XLINK_NS, 'href', '#4_focus')
		contextFocusIcon.appendChild(focusIcon)

		let contextFocusText = document.createElement('div')
		contextFocusText.className = 'context-menu-text'
        contextFocusText.textContent = this.translate('ID_RIBBON_FOCUS', this.lang);

		$(contexFocusRow).click(() => {
			this.callContextSelectionMethod('Focus')
		})
		contexFocusRow.appendChild(contextFocusIcon)
		contexFocusRow.appendChild(contextFocusText)


		let secondDivider = document.createElement('hr')


		//Create 'Extract faces' entry
		let contextExtractFacesRow = document.createElement('div')
		contextExtractFacesRow.className = 'context-menu-row'

		let contextExtractFacesIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contextExtractFacesIcon).addClass('context-menu-icon')
		let extractFacesIcon = document.createElementNS(SVG_NS, 'use')
		extractFacesIcon.setAttributeNS(XLINK_NS, 'href', '#1_flaeche_extrahieren')
		contextExtractFacesIcon.appendChild(extractFacesIcon)

		let contextExtractFacesText = document.createElement('div')
		contextExtractFacesText.className = 'context-menu-text'
        contextExtractFacesText.textContent = this.translate('ID_RIBBON_EXTRACT_FACES', this.lang);

		$(contextExtractFacesRow).click(() => {
			this.callContextSelectionMethod('ExtractFaces')
		})
		contextExtractFacesRow.appendChild(contextExtractFacesIcon)
        contextExtractFacesRow.appendChild(contextExtractFacesText)

        //Create 'Merge objects' entry
        let contextMergeObjectsRow = document.createElement('div');
        contextMergeObjectsRow.className = 'context-menu-row';

        let contextMergeObjectsIcon = <SVGSVGElement> document.createElementNS(SVG_NS, 'svg');
        $(contextMergeObjectsIcon).addClass('context-menu-icon');
        let mergeObjectsIcon = document.createElementNS(SVG_NS, 'use');
        mergeObjectsIcon.setAttributeNS(XLINK_NS, 'href', '#merge_objects');
        contextMergeObjectsIcon.appendChild(mergeObjectsIcon);

        let contextMergeObjectsText = document.createElement('div');
        contextMergeObjectsText.className = 'context-menu-text';
        contextMergeObjectsText.textContent = this.translate('ID_RIBBON_MERGE_OBJECTS', this.lang);

        $(contextMergeObjectsRow).click(() =>
        {
            this.callContextSelectionMethod('MergeObjects');
        });
        contextMergeObjectsRow.appendChild(contextMergeObjectsIcon);
        contextMergeObjectsRow.appendChild(contextMergeObjectsText);

        //Create 'Merge objects rec' entry
        let contextMergeObjectsRecRow = document.createElement('div');
        contextMergeObjectsRecRow.className = 'context-menu-row';

        let contextMergeObjectsRecIcon = <SVGSVGElement> document.createElementNS(SVG_NS, 'svg');
        $(contextMergeObjectsRecIcon).addClass('context-menu-icon');
        let mergeObjectsRecIcon = document.createElementNS(SVG_NS, 'use');
        mergeObjectsRecIcon.setAttributeNS(XLINK_NS, 'href', '#merge_objects_rec');
        contextMergeObjectsRecIcon.appendChild(mergeObjectsRecIcon);

        let contextMergeObjectsRecText = document.createElement('div');
        contextMergeObjectsRecText.className = 'context-menu-text';
        contextMergeObjectsRecText.textContent = this.translate('ID_RIBBON_MERGE_OBJECTS_HIERARCHICAL', this.lang);

        $(contextMergeObjectsRecRow).click(() =>
        {
            this.callContextSelectionMethod('MergeObjectsHierarchically');
        });
        contextMergeObjectsRecRow.appendChild(contextMergeObjectsRecIcon);
        contextMergeObjectsRecRow.appendChild(contextMergeObjectsRecText);

        //Create 'Retessellate' entry
        let contextRetessellateRow = document.createElement('div')
		contextRetessellateRow.className = 'context-menu-row'

		let contexRetessellateIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg')
		$(contexRetessellateIcon).addClass('context-menu-icon')
		let retessellateIcon = document.createElementNS(SVG_NS, 'use')
        retessellateIcon.setAttributeNS(XLINK_NS, 'href', '#retessellate')
		contexRetessellateIcon.appendChild(retessellateIcon)

		let contextRetessellateText = document.createElement('div')
		contextRetessellateText.className = 'context-menu-text'
        contextRetessellateText.textContent = this.translate('ID_RIBBON_RETESSELLATE', this.lang);

		let dropdownIcon = document.createElement('i');
		dropdownIcon.className = 'fas fa-caret-right context-menu-dropdown-icon';

		contextRetessellateRow.appendChild(contexRetessellateIcon)
		contextRetessellateRow.appendChild(contextRetessellateText)
		contextRetessellateRow.appendChild(dropdownIcon)

		//Create 'Replace Node' entry
		let contextReplaceNodeRow = document.createElement('div');
		contextReplaceNodeRow.className = 'context-menu-row';

		let contextReplaceNodeIcon = <SVGSVGElement> document.createElementNS(SVG_NS, 'svg');
		$(contextReplaceNodeIcon).addClass('context-menu-icon');
		let replaceNodeIcon = document.createElementNS(SVG_NS, 'use');
		replaceNodeIcon.setAttributeNS(XLINK_NS, 'href', '#align_best_fit');
		contextReplaceNodeIcon.appendChild(replaceNodeIcon);

		let contextReplaceNodeText = document.createElement('div');
		contextReplaceNodeText.className = 'context-menu-text';
		contextReplaceNodeText.textContent = this.translate('ID_REPLACE_NODE', this.lang);

		$(contextReplaceNodeRow).click(() =>
		{
			const xml = '<Call Method="ActivateInteraction"><Interaction>ReplaceNode</Interaction></Call>';
			this.callContextApiMethod(xml);
		});
		contextReplaceNodeRow.appendChild(contextReplaceNodeIcon);
		contextReplaceNodeRow.appendChild(contextReplaceNodeText);

		contextMenu.appendChild(contextHideRow)
		contextMenu.appendChild(contextShowRow)
        contextMenu.appendChild(contextIsolateRow)
        contextMenu.appendChild(contextShowAllRow)
		contextMenu.appendChild(contextInvertVisRow)
		contextMenu.appendChild(contextDeleteRow)
		contextMenu.appendChild(contextGhostRow)
		contextMenu.appendChild(contextUnGhostRow)
		contextMenu.appendChild(firstDivider)
		contextMenu.appendChild(contextActivateCSRow)
		contextMenu.appendChild(contextResetCSRow)
		contextMenu.appendChild(contexFocusRow)
		contextMenu.appendChild(secondDivider)
        contextMenu.appendChild(contextExtractFacesRow)
        contextMenu.appendChild(contextMergeObjectsRow)
        contextMenu.appendChild(contextMergeObjectsRecRow)
		contextMenu.appendChild(contextRetessellateRow)
		contextMenu.appendChild(contextReplaceNodeRow)
		document.body.appendChild(contextMenu)

		let tesselationDropDown = this.createTesselationDropdown(contextMenu);

		$(contextRetessellateRow).hover(() =>
		{
			$(tesselationDropDown).show();
			$(contextMenu).mouseover((ev) =>
			{
				if (!$.contains(contextRetessellateRow, ev.target) && ev.target !== contextRetessellateRow && ev.target !== contextMenu && !$.contains(tesselationDropDown, ev.target))
				{
					$(tesselationDropDown).hide();
				}
			})
		})

		$(tesselationDropDown).hide();

		let menuHeight = $(contextMenu).outerHeight()
		let menuWidth =	$(contextMenu).outerWidth()
		let bodyHeight = $(document.body).height()
		let bodyWidth = $(document.body).width()
		let dropDownWidth = $(tesselationDropDown).width();
		if(ev.pageY + menuHeight > bodyHeight)
		{
			let diff = bodyHeight - (ev.pageY + menuHeight)
			let top = parseInt($(contextMenu).css('top'))
			contextMenu.style.top = top + diff +'px'
		}
		if(ev.pageX + menuWidth > bodyWidth)
		{
			let diff = bodyWidth - (ev.pageX + menuWidth)
			let left = parseInt($(contextMenu).css('left'))
			contextMenu.style.left = left + diff + 5 + 'px'
		}

		if (ev.pageX + menuWidth + dropDownWidth > bodyWidth)
		{
			tesselationDropDown.style.left = (-1 * parseInt($(tesselationDropDown).css('left'))) + 'px';
		}
		$(document).on('mousedown', this.closeContextMenu)
		$(document).on('keyup', this.closeContextMenu)
	}
	
	callContextApiMethod(xml) {
		this.client.command.executeXML(xml)
		const mockEvent = {
			keyCode: 27,
			type: 'keyup'
		}
		this.closeContextMenu(mockEvent)
	}

	callContextMethod(method) {
		const xml = '<Call Method="' + method + '"></Call>'
		this.callContextApiMethod(xml)
	}
	
	callContextSelectionMethod(selection) {
		const xml = '<Call Method="ModifySelection"><SelectionModifier>' + selection + '</SelectionModifier></Call>'
		this.callContextApiMethod(xml)
	}

	closeContextMenu(e)
	{
		let menu = document.getElementById('contextMenu')
        if(menu && (!menu.contains(e.target) && e.type === 'mousedown') || (e.type === 'keyup' && e.keyCode === 27))
        {
            $('#contextMenu').remove()
            $(document).off('mousedown', this.closeContextMenu)
            $(document).off('keyup', this.closeContextMenu)
        }
	}

	createTesselationDropdown(contextMenu: HTMLElement)
	{
		let mockEvent = {
			keyCode: 27,
			type: 'keyup'
		};
		let retessellateDropdownWrapper = document.createElement('div');
		retessellateDropdownWrapper.className = 'context-menu-dropdown-wrapper';

		let tesselationExtraLowRow = document.createElement('div');
		tesselationExtraLowRow.className = 'context-menu-row';

		let dropdownTesselationExtraLowIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationExtraLowIcon).addClass('context-menu-icon');
		let tesselationExtraLowIcon = document.createElementNS(SVG_NS, 'use');
		tesselationExtraLowIcon.setAttributeNS(XLINK_NS, 'href', '#extra_low_tesselation');
		dropdownTesselationExtraLowIcon.appendChild(tesselationExtraLowIcon);

		let dropdownTesselationExtraLowText = document.createElement('div');
		dropdownTesselationExtraLowText.className = 'context-menu-text';
		dropdownTesselationExtraLowText.textContent = this.translate('ID_RIBBON_EXTRALOW', this.lang);

		tesselationExtraLowRow.appendChild(dropdownTesselationExtraLowIcon);
		tesselationExtraLowRow.appendChild(dropdownTesselationExtraLowText);

		$(tesselationExtraLowRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>ExtraLow</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		let tesselationLowRow = document.createElement('div');
		tesselationLowRow.className = 'context-menu-row';

		let dropdownTesselationLowIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationLowIcon).addClass('context-menu-icon');
		let tesselationLowIcon = document.createElementNS(SVG_NS, 'use');
		tesselationLowIcon.setAttributeNS(XLINK_NS, 'href', '#low_tesselation');
		dropdownTesselationLowIcon.appendChild(tesselationLowIcon);

		let dropdownTesselationLowText = document.createElement('div');
		dropdownTesselationLowText.className = 'context-menu-text';
		dropdownTesselationLowText.textContent = this.translate('ID_RIBBON_LOW', this.lang);

		tesselationLowRow.appendChild(dropdownTesselationLowIcon);
		tesselationLowRow.appendChild(dropdownTesselationLowText);

		$(tesselationLowRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>Low</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		let tesselationMediumRow = document.createElement('div');
		tesselationMediumRow.className = 'context-menu-row';

		let dropdownTesselationMediumIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationMediumIcon).addClass('context-menu-icon');
		let tesselationMediumIcon = document.createElementNS(SVG_NS, 'use');
		tesselationMediumIcon.setAttributeNS(XLINK_NS, 'href', '#medium_tesselation');
		dropdownTesselationMediumIcon.appendChild(tesselationMediumIcon);

		let dropdownTesselationMediumText = document.createElement('div');
		dropdownTesselationMediumText.className = 'context-menu-text';
		dropdownTesselationMediumText.textContent = this.translate('ID_RIBBON_MEDIUM', this.lang);

		tesselationMediumRow.appendChild(dropdownTesselationMediumIcon);
		tesselationMediumRow.appendChild(dropdownTesselationMediumText);

		$(tesselationMediumRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>Medium</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		let tesselationHighRow = document.createElement('div');
		tesselationHighRow.className = 'context-menu-row';

		let dropdownTesselationHighIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationHighIcon).addClass('context-menu-icon');
		let tesselationHighIcon = document.createElementNS(SVG_NS, 'use');
		tesselationHighIcon.setAttributeNS(XLINK_NS, 'href', '#high_tesselation');
		dropdownTesselationHighIcon.appendChild(tesselationHighIcon);

		let dropdownTesselationHighText = document.createElement('div');
		dropdownTesselationHighText.className = 'context-menu-text';
        dropdownTesselationHighText.textContent = this.translate('ID_RIBBON_HIGH', this.lang);

		tesselationHighRow.appendChild(dropdownTesselationHighIcon);
		tesselationHighRow.appendChild(dropdownTesselationHighText);

		$(tesselationHighRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>High</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		let tesselationExtraHighRow = document.createElement('div');
		tesselationExtraHighRow.className = 'context-menu-row';

		let dropdownTesselationExtraHighIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationExtraHighIcon).addClass('context-menu-icon');
		let tesselationExtraHighIcon = document.createElementNS(SVG_NS, 'use');
		tesselationExtraHighIcon.setAttributeNS(XLINK_NS, 'href', '#extra_high_tesselation');
		dropdownTesselationExtraHighIcon.appendChild(tesselationExtraHighIcon);

		let dropdownTesselationExtraHighText = document.createElement('div');
		dropdownTesselationExtraHighText.className = 'context-menu-text';
		dropdownTesselationExtraHighText.textContent = this.translate('ID_RIBBON_EXTRAHIGH', this.lang);

		tesselationExtraHighRow.appendChild(dropdownTesselationExtraHighIcon);
		tesselationExtraHighRow.appendChild(dropdownTesselationExtraHighText);

		$(tesselationExtraHighRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>ExtraHigh</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		let tesselationCustomRow = document.createElement('div');
		tesselationCustomRow.className = 'context-menu-row';

		let dropdownTesselationCustomIcon = <SVGSVGElement>document.createElementNS(SVG_NS, 'svg');
		$(dropdownTesselationCustomIcon).addClass('context-menu-icon');
		let tesselationCustomIcon = document.createElementNS(SVG_NS, 'use');
		tesselationCustomIcon.setAttributeNS(XLINK_NS, 'href', '#custom_tesselation');
		dropdownTesselationCustomIcon.appendChild(tesselationCustomIcon);

		let dropdownTesselationCustomText = document.createElement('div');
		dropdownTesselationCustomText.className = 'context-menu-text';
		dropdownTesselationCustomText.textContent = this.translate('ID_RIBBON_USER_DEFINED', this.lang);

		tesselationCustomRow.appendChild(dropdownTesselationCustomIcon);
		tesselationCustomRow.appendChild(dropdownTesselationCustomText);

		$(tesselationCustomRow).click(() =>
		{
			let xml = '<Call Method="Retessellate"><Level>Userdefined</Level></Call>';
			this.client.command.executeXML(xml);
			this.closeContextMenu(mockEvent);
		});


		retessellateDropdownWrapper.appendChild(tesselationExtraLowRow);
		retessellateDropdownWrapper.appendChild(tesselationLowRow);
		retessellateDropdownWrapper.appendChild(tesselationMediumRow);
		retessellateDropdownWrapper.appendChild(tesselationHighRow);
		retessellateDropdownWrapper.appendChild(tesselationExtraHighRow);
		retessellateDropdownWrapper.appendChild(tesselationCustomRow);

		contextMenu.appendChild(retessellateDropdownWrapper);

		$(retessellateDropdownWrapper).blur(() =>
		{
			$(retessellateDropdownWrapper).remove();
		})

		return retessellateDropdownWrapper;
	}

	// initDecoder

	putImage(base64Image: string) {
        this.client.stats.logRecvImage(base64Image.length);
        this.image.src = base64Image;
        if (this.image.width === 0)
        {
            setTimeout(() =>
            {
                this.client.emit('imageReceived', { width: this.image.width, height: this.image.height, image: base64Image });
                if (this.client.initOptions.spectatorMode)
                {
                    this.putImage(base64Image);
                }
            }, 0);
        }
        else
        {
            this.client.emit('imageReceived', { width: this.image.width, height: this.image.height, image: base64Image });
        }

        if (this.modeTransition === true)
        {
            this.canvas2D.style.display = 'block';
            this.modeTransition = false;
        }
    }

	setMode(canvasMode: CanvasMode) {
		switch (canvasMode) {
			case 'image':
				this.scaleFactor = 1.0
				this.modeTransition = true
				return true
		}
	}

	resize(width: number, height: number) {
		this.width = width
		this.height = height
		//Draw current canvas to temp canvas
		if (this.client.initOptions.showBackgroundCanvas && this.image.src !== "vs_logo.svg" && this.image.src !== "")
		{
			this.tmpCanvas.width = width;
			this.tmpCanvas.height = height;
			let tmpCtx = this.tmpCanvas.getContext('2d');
			tmpCtx.drawImage(this.canvas2D.getContext('2d').canvas, 0, 0);
		}

		this.canvas2D.width = width
		this.canvas2D.height = height
		//Multisessions
		if (this.client.initOptions.showSpectatorCanvas)
		{
			this.mouseLayer.width = width;
			this.mouseLayer.height = height;
		}


		// use the default factor 1.0
		this.scaleFactor = 1.0

		if(this.image.src === "") {
            var img = new Image()
            var ctx = this.canvas2D.getContext('2d')

            if (!this.client.initOptions || (this.client.initOptions && !this.client.initOptions.skipVSLogo))
            {
                img.src = 'vs_logo.svg';

                img.onload = () =>
                {
                    if (this.canvas2D.width > 20 && this.canvas2D.height > 20)
                    {
                        var logoWidth;
                        if (this.canvas2D.width <= this.canvas2D.height)
                        {
                            logoWidth = this.canvas2D.width / 2;
                        }
                        else
                        {
                            logoWidth = this.canvas2D.height / 2;
                        }
                        var posX = (this.canvas2D.width - logoWidth) / 2;
                        var posY = (this.canvas2D.height - logoWidth) / 2;
                        ctx.drawImage(img, posX, posY, logoWidth, logoWidth);
                    }
                }
            }
			// var img = new Image()
			// var ctx = this.canvas2D.getContext('2d')
			// if(typeof InstallTrigger !== 'undefined')
			// {
			// 	img.src = 'wallpaperFF.svg'
			// }
			// else{
			// 	img.src = 'wallpaper.svg'
			// }
			// img.onload = () => {
			// 	ctx.drawImage(img, 0, 0, this.canvas2D.width, this.canvas2D.height)
			// }
		}
    }

    setDefaultImage ()
    {
        var img = new Image();
        var ctx = this.canvas2D.getContext('2d');
        img.src = 'vs_logo.svg';
        img.onload = () =>
        {
            if (this.canvas2D.width > 20 && this.canvas2D.height > 20)
            {
                var logoWidth;
                if (this.canvas2D.width <= this.canvas2D.height)
                {
                    logoWidth = this.canvas2D.width / 2;
                }
                else
                {
                    logoWidth = this.canvas2D.height / 2;
                }
                var posX = (this.canvas2D.width - logoWidth) / 2;
                var posY = (this.canvas2D.height - logoWidth) / 2;
                ctx.clearRect(0,0,this.canvas2D.width, this.canvas2D.height);
                ctx.drawImage(img, posX, posY, logoWidth, logoWidth);
            }
        }
    }

	startRect(x: number, y: number) {
		this.rectStartX = x
		this.rectStartY = y
	}

	drawRectImage(x: number, y: number) {
		this.context2D.drawImage(this.image, 0, 0, this.image.width, this.image.height, 0, 0, this.canvas2D.width, this.canvas2D.height)
		this.context2D.beginPath()
		this.context2D.rect(this.rectStartX, this.rectStartY, x - this.rectStartX, y - this.rectStartY)
		this.context2D.lineWidth = 1
		this.context2D.strokeStyle = 'red'
		this.context2D.stroke()
	}

}